import { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  IHOMEPAGEData,
  OtpResData,
  OtpRespone,
  IRESAllData,
} from "../../shared/commonUtils";
import useTranslationHook from "../useTranslationHook";
import { URL_CONSTANTS, apiVersion } from "../../axios/urlsLinkRjs";
import { httpPost, httpPostDukany } from "../../axios/axiosUtils";
import {
  getBussinessData,
  showErrortMessage,
  showSuccesstMessage,
} from "../../shared/helpersMethod";
import { AxiosError, AxiosResponse } from "axios";
import useGetToken from "../useGetToken";

const useSendOtp = () => {
  const [loading, setLoading] = useState(false);
  const [otpData, setOtpData] = useState<OtpRespone>();
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();
  const { t } = useTranslationHook();
  const { getToken } = useGetToken();
  const { bussinessData }: any = useSelector(
    (state: any) => state.bussinessData
  );
  const [customerData, setCustomerData] = useState<OtpResData>();

  // Prevent multiple simultaneous API calls
  const apiCallInProgress = useRef(false);

  const sendOtpHandler = async (
    mobile_number: string,
    country: string,
    msgType: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return;
      }
    }

    apiCallInProgress.current = true;
    setLoading(true);

    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Send_Otp")!,
        {
          id: bussinessData.businessID,
          mobile_number,
          name: bussinessData.businessName,
          msgType,
          lang: bussinessData.defaultLang,
          country,
        },
        {},
        bussinessToken.accessToken
      );
      console.log("before condition", res);
      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return sendOtpHandler(mobile_number, country, msgType, true);
        }
        return;
      }

      if (res.type === "success") {
        setOtpData(res);
        showSuccesstMessage("Otp sent successfully");
        localStorage.setItem("otpDataTemp", JSON.stringify(res));
      }
      setErrorMessage(res.message);
    } catch (error: any) {
      setErrorMessage(error.response.data.message);
      console.log(error);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const validOtpHandler = async (
    req_id: string,
    mobile_number: string,
    otp: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return;
      }
    }

    apiCallInProgress.current = true;
    setLoading(true);

    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Validate_Otp")!,
        {
          req_id,
          otp,
          mobile_number,
          apiVersion,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return validOtpHandler(req_id, mobile_number, otp, true);
        }
        return;
      }

      console.log(res);
      if (res.type === "success") {
        setCustomerData(res);
      } else {
        showErrortMessage(res.message);
        setErrorMessage(res.message);
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response.data?.message) {
          showErrortMessage(t("txt_invalid_otp"));
          setErrorMessage(t("txt_invalid_otp"));
        }
      }
      console.log(error);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  return {
    sendOtpHandler,
    validOtpHandler,
    loading,
    otpData,
    errorMessage,
    customerData,
  };
};

export default useSendOtp;
